import { useTranslation } from "react-i18next";

import SetupYourAccountBGV2 from "../../../../assets/images/payments/set-up-your-account-bg-v2.png";
import { NoPaymentAccountsViewProps } from "../../payment.types";

import PaymentAndBilling from "./PaymentAndBilling";
import WhyUsePaymentLinks from "./WhyUsePaymentLinks";
import SetupPaymentAccount from "./SetupPaymentAccount";
import PaymentOverviewAccordion from "./PaymentOverviewAccordion";

const NoPaymentAccountsView = ({
  openLearnMorePopUp,
  handleSetupPaymentAccount,
  handleAddReceivingDetails,
}: NoPaymentAccountsViewProps) => {
  const { t } = useTranslation();

  return (
    <>
      <PaymentOverviewAccordion heading={t("pages.payment.header.paymentBilling")} summary={<PaymentAndBilling />} />
      <PaymentOverviewAccordion
        heading={t("pages.payment.overview.setupYourPaymentAccount")}
        summary={
          <SetupPaymentAccount
            openLearnMorePopUp={openLearnMorePopUp}
            handleSetupPaymentAccount={handleSetupPaymentAccount}
            handleAddReceivingDetails={handleAddReceivingDetails}
          />
        }
        bg={SetupYourAccountBGV2}
      />
      <PaymentOverviewAccordion
        heading={t("pages.payment.overview.whyUsePaymentLinks")}
        summary={<WhyUsePaymentLinks />}
      />
    </>
  );
};

export default NoPaymentAccountsView;
